<template>
<div class="page-content-wrapper">
  <div class="page-content apiacs">
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar">
      <ul class="page-breadcrumb">
        <li>
          <i class="fa fa-home"></i>
          <a href="index.html">首页</a>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <a href="#">API访问控制</a>
        </li>
      </ul>
    </div>
    <!-- END PAGE HEADER-->
    <div id="search-bar" class="row" style="margin-top:15px">

      <div class="col-md-5 lp-flex-box">
        <label class="control-label" style="width:70px">API名称</label>
        <select class="form-control" style="flex-grow:1" v-model="biz.api_name">
          <option value="">选择API名称</option>
          <option v-for="(item, index) in biz.api_names" :value="item">{{item}}</option>
        </select>
      </div>

      <div class="col-md-4 lp-flex-box">
        <label class="control-label" style="width:60px">CALLER</label>
        <select class="form-control" style="flex-grow:1" v-model="biz.caller">
          <option value="">选择CALLER</option>
          <option v-for="(item, index) in biz.callers" :value="item">{{item}}</option>
        </select>
      </div>

      <div class="col-md-3" style="text-align:right">
        <button type="button" class="btn blue" @click="search">查询<i class="m-icon-swapright m-icon-white"></i></button>
        <button type="button" class="btn green" @click="detail(0)">新增配置<i class="icon-plus m-icon-white"></i></button>
      </div>
    </div>
    <br>
    <table class="table table-striped table-hover table-bordered table-condensed">
      <thead>
        <tr>
          <th width="20%" class="text_overflow">API名称</th>
          <th class="text_overflow">CALLER</th>
          <th width="20%" class="text_overflow">是否检查SESSION</th>
          <th width="20%" class="text_overflow">是否检查SIGN</th>
          <th width="15%">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in biz.items">
          <td style="vertical-align:middle" class="text_overflow">{{item.api_name}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{item.caller}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{item.need_check_session}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{item.need_check_sign}}</td>
          <td>
            <a href="javascript:void(0)" @click="detail(item.id)">详情</a>|
            <a href="javascript:void(0)" @click="remove(item.id)">删除</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="pager-bar">
      <pager :page-index="pageIndex" :page-size="pageSize" :total-count="totalCount" :action="query" @page-change="onPageChange"></pager>
    </div>
  </div>
</div>
</template>

<script>
import http from '../../lib/utils/request.js'
import Pager from '../fragment/Pager.vue'
import ApiAcsEdit from './ApiAcsEdit.vue'
import {mapState} from 'vuex'
import mixins from '../../mixins/index'
import common from '../../lib/methods/common.js'
import {MSG_ID, SER_RESP_CODE} from '../../lib/constant.js'
export default {
  name: 'apiacs',
  mixins: mixins,
  data () {
    return {
      biz: {
        items: [],
        api_name: '',
        caller: '',
        api_names: [],
        callers: []
      },
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0
    }
  },
  components: {
    ApiAcsEdit,
    Pager
  },
  created () {
    window.emitter.on(MSG_ID.MSG_APIACS_SET_SUCCESS, (...args) => {
      this.query()
    })
  },
  mounted () {
    this.query()
  },
  methods: {
    onPageChange (pageIndex) {
      this.query()
    },
    search () {
      this.resetPager()
      this.query()
    },
    query () {
      let that = this
      let reqdata = {page_index: this.pager.pageIndex, page_size: this.pageSize, account: this.uid(), api_name: this.biz.api_name, caller: this.biz.caller}
      http.invoke('auth.pageApiAcs', reqdata, function (data) {
        that.biz.items = data.content
        that.totalCount = data.total_count
        if (data.ext) {
          that.biz.api_names = data.ext.api_names
          that.biz.callers = data.ext.callers
        }
      })
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, ApiAcsEdit, {title: '编辑访问控制', id: id})
    },
    remove (id) {
      window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '删除访问控制定义', (data) => {
        let reqdata = {action: 2, id: id}
        http.invoke('auth.setApiAcs', reqdata, (data) => {
          window.emitter.emit(MSG_ID.MSG_APIACS_SET_SUCCESS)
        }, (state) => {
          if (state.code !== 2000000) {
            window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, SER_RESP_CODE[state.code])
            return
          }
          switch (state.result) {
            case 1:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '访问控制正在被使用,不能删除')
              break
            default:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '登录失败')
          }
        })
      })
    },
    ...common
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.apiacs {
  background-color: #fff;
}
#pager-bar {
  text-align: center;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// ApiAcs.vue?26bee71e